module.exports = __webpack_public_path__ + "static/img/Tiger.1a8ebfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/cz_animal/Tiger.svg
// module id = 1369
// module chunks = 0